var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",class:{
		'skeleton--shimmer': _vm.shimmer,
		'skeleton--gradient': _vm.gradient,
	},style:(_vm.style)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }